export const UK_REGIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'S'] as const

export type UkRegion = (typeof UK_REGIONS)[number]
